export default "/images/265d1413dfc2cbffde1afbd98f2a2ff0.avif";